<template lang="pug">
  #ReservationEdit.container-width
    .p-3
      .container
        .d-flex.align-items-center.justify-content-center
          div(style="letter-spacing: 5px; font-weight: bold; font-size: 1.2rem; margin-bottom: 5px;") 修改預約
        .d-flex.align-items-center.justify-content-center(style="flex-direction: column;")
          input.inputStyle(
            type='text', placeholder="請輸入姓名" v-model='userInfo.name')
          input.inputStyle(
            type='text', placeholder="請輸入行動電話" v-model='userInfo.mobile')
        .multiselect_custom_homePage
          multiselect(
            label="name",
            tracy-by="activity_reserve_store_id"
            placeholder="請選擇活動",
            :options="activityDropdown",
            :searchable="false",
            :allow-empty="false",
            v-model="userInfo.selectedStore",
            selectLabel='',
            deselect-label='',
            @input='getActivityTimeList'
            noOptions="無可選擇活動"
          )
            template(slot="noOptions")
              strong 無可選擇活動
        .multiselect_custom_homePage
          multiselect(
            track-by="activity_start_at",
            label="activity_start_at",
            placeholder="請選擇活動日期",
            :options="activityTimeList",
            :searchable="false",
            :allow-empty="false",
            v-model="userInfo.selectedDate",
            selectLabel='',
            deselect-label='',
            @input='getStoreActivitySession'
            noOptions="無可選擇日期"
          )
            template(slot="noOptions")
              strong 無可選擇日期
        .multiselect_custom_homePage
          multiselect(
            track-by="id",
            label="period_limit",
            placeholder="請選擇活動時段",
            :options="activitySessionList",
            :searchable="false",
            v-model="userInfo.selectedTime",
            selectLabel='',
            deselect-label='',
            noOptions="無可選擇時段"
          )
            template(slot="noOptions")
              strong 無可選擇時段
        textarea.inputStyle.textareaStyle.d-flex.align-items-center.justify-content-center(
          type='text', placeholder="請輸入備註" v-model='userInfo.sa_note', style="margin: 5px 0;")

        .d-flex(style='justify-content: space-around')
          button.btn.btn-primary.mt-4.mb-3(type="button", @click="$router.go(-1)", style="width: 40%;")
            span(style="margin-right: 10px;") 取消
          button.btn.btn-primary.mt-4.mb-3(type="button", @click="goItemList()", style="width: 40%;")
            span(style="margin-right: 10px;") 送出

</template>

<script>
import { mapState } from 'vuex';
const _ = require('lodash');
import { SA_EVENT_ACTIVITY_INDEX } from '@/router/sa/event-activity';

  export default {

// 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'event-activity-sa-create',
  props: {
    id: [String, Number]
  },
  data() {
    return {
      couponList: [],
      testStoreOptions: [{ id: 1, store: '台北101店' }, { id: 2, store: '台中遠百店' }],
      actInfo: {
        title: '活動主題活動主題',
        content: '活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明',
        actImg: 'https://images.chinatimes.com/newsphoto/2017-03-17/1024/20170317005512.jpg',
        hint: ['1. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '2. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '3. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。'],
        actDateList: ['2021/12/01', '2021/12/02', '2021/12/03'],
        actDateTimeList: ['11:00', '14:00', '17:00']
      },
      userInfo: {},
      agreeUseRule: [],
      activitySessionList: [],
      isSend: false,
    };
  },
  methods: {
    goItemList() {
      const vm = this;
      const MobileReg = /^(09)[0-9]{8}$/;
      if (!vm.userInfo.name) {
        vm.$swal.fire({
          title: '請輸入姓名',
          icon: 'info'
        });
      } else if (!vm.userInfo.mobile) {
        vm.$swal.fire({
          title: '請輸入行動電話',
          icon: 'info'
        });
      } else if (!MobileReg.test(vm.userInfo.mobile)) {
        vm.$swal.fire({
          title: '行動電話格式錯誤',
          icon: 'info'
        });
      } else if (!vm.userInfo.selectedTime) {
        vm.$swal.fire({
          title: '請選擇活動時段',
          icon: 'info'
        });
      } else {
        if (vm.isSend) return;
        vm.isSend = true;

        vm.$swal.fire({
          title: '資料送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        const input = {
          activity_reserve_detail_id: vm.userInfo.selectedTime.id,
          line_uuid: vm.editData.line_uuid,
          meta: {
            name: vm.userInfo.name,
            mobile: vm.userInfo.mobile
          },
          sa_note: vm.userInfo.sa_note
        };

        vm.$store.dispatch('sa_event_activity/editEventActivityHandler', { id: vm.id, input }).then(() => {
          vm.$swal.close();
          vm.$snotify.success(null, '編輯活動預約成功');
          vm.isSend = false;
          vm.$router.push({ name: SA_EVENT_ACTIVITY_INDEX });
        }).catch(() => {
          vm.isSend = false;
        });
      }
    },
    getStoreActivitySession(val) {
      const vm = this;
      vm.$set(vm.userInfo, 'selectedTime', null);
      vm.$set(vm, 'activitySessionList', []);
      vm.activitySessionList = val.activity_detail;
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.invite_id === vm.invitations[index].invite_id);
      if (key) {
        return true;
      }
      return false;
    },
    getActivityTimeList(val) {
      const vm = this;
      vm.$set(vm.userInfo, 'selectedDate', null);
      vm.$set(vm.userInfo, 'selectedTime', null);
      vm.$store.commit('sa_event_activity/setActivityTimeList', []);
      vm.$set(vm, 'activitySessionList', []);
      this.$nextTick(function () {
        vm.$swal.fire({
          title: '取得日期時段中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_event_activity/getActivityTimeListHandler', val.activity_reserve_store_id).then(() => {
          vm.$swal.close();
        });
      });
    },
  },
  watch: {
    'userInfo.mobile': function (val) {
      this.userInfo.mobile = String(val).replace(/[^0-9]+$/, '');
    }
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);

    // 避免重整拿不到store 及活動下拉重新取得
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得店鋪id拿活動下拉
    vm.$store.dispatch('sa_profile/getProfileHandler').then((res) => {
      vm.nowSelectStore = vm.profile.stores[0];
      // 取得活動下拉
      vm.$store.dispatch('sa_event_activity/getActivityDropdownHandler', vm.nowSelectStore.id).then(() => {
        vm.$store.dispatch('sa_event_activity/getEditDataHandler', vm.id).then(() => {
          // 放姓名 手機
          vm.userInfo = _.cloneDeep(vm.editData.meta);
          vm.sa_note = _.cloneDeep(vm.editData.sa_note);
          // 放活動
          const activityKey = _.findKey(vm.activityDropdown, (val) => val.activity_reserve_store_id === vm.editData.details.activity_reserve_store_id);
          vm.userInfo.selectedStore = vm.activityDropdown[activityKey];

          // 取得日期下拉
          vm.$store.dispatch('sa_event_activity/getActivityTimeListHandler', vm.userInfo.selectedStore.activity_reserve_store_id).then(() => {
            // 放日期
            const activityDateKey = _.findKey(vm.activityTimeList, (val) => val.activity_start_at === vm.editData.details.activity_at);
            vm.$set(vm.userInfo, 'selectedDate', vm.activityTimeList[activityDateKey]);
            vm.activitySessionList = vm.activityTimeList[activityDateKey].activity_detail;
            // 放時間
            const activityTimeKey = _.findKey(vm.activitySessionList, (val) => val.id === vm.editData.details.id);
            vm.$set(vm.userInfo, 'selectedTime', vm.activitySessionList[activityTimeKey]);
            vm.$swal.close();
          });
        });
      });
    });
  },
  computed: {
    ...mapState({
      activityDropdown: (state) => state.sa_event_activity.activityDropdown,
      profile: (state) => state.sa_profile.data,
      editData: (state) => state.sa_event_activity.editData,
      activityTimeList: (state) => state.sa_event_activity.activityTimeList,
    })
  }
};
</script>
<style lang="scss" scoped>
.line {
  border-top: solid 1px #aaa;
  width: 100%;
  height: 1px;
}

.container {
  padding: 35px 20px;
  text-align: left;
}

.inputStyle {
  width: 100%;
  padding: 15px;
  text-align: center;
  margin: 5px;
  border: none;
  background: #eee;
}
.footer {
  border-top: solid #aaa 1px;
  padding: 20px;
}
.multiselect_custom_homePage {
  padding: 5px 0;
  & .multiselect__placeholder {
    color: #828282;
    margin-left: 20px;
    font-size: 1rem;
  }
  & .multiselect__tags {
    border: solid #888 1px;
    border-radius: 3px;
    min-height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .multiselect__input, .multiselect__single {
    text-align: center;
  }
  & .multiselect__select {
    top: 9px;
  }
  & .multiselect__content-wrapper {
    text-align: center;
  }
}
textarea:hover, input:hover, textarea:active, input:active, textarea:focus, input:focus, button:focus, button:active, button:hover, label:focus, .btn:active, .btn.active {
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
}
</style>
